import ApiModule from './index'
import BaseModel from '../../base/BaseModel'
import { _ as UtilExt } from '@iskytrip/sdk'
import { UtilDevice, Bridge } from '@iskytrip/sdk'
import { Toast, Alert } from '@components/index'

export * from './wirelessModule/index'

export class GetCouponUseJumpUrl extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.WIRELESS
		this.url = '/coupon/getCouponUseJumpUrl'
		this.desc = '根据优惠卷id提供跳转URL'
	}

	dataformat(json) {
		super.dataformat(json)

		return json.resultData || {}
	}
}

/**
 * @brief 非商城产品
 */
export class QueryCouponProductList extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.WIRELESS
		this.url = '/coupon/queryCouponProductList'
		this.desc = '根据优惠卷id查询适用的商品列表'
	}

	dataformat(json) {
		super.dataformat(json)

		return {
			pages: (json.resultData || {}).pages || 0,
			total: (json.resultData || {}).pageTotal || 0,
			current: (json.resultData || {}).pageIndex || 0,
			list: ((json.resultData || {}).list || []).map((it) => ({
				url: it.url,
				id: it.productId,
				price: it.minPrice,
				name: it.productName,
				thumnail: it.headImageUrl,
				subName: it.productSubtitle,
			})),
		}
	}
}

export class GetEquity extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userEquity/equityPackageGetEquity'
		this.desc = '领取日上优选券'
	}
}

/**
 * @brief 商城商品
 */
export class QueryCouponMallProductList extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.WIRELESS
		this.url = '/coupon/queryCouponMallProductList'
		this.desc = '根据优惠卷id查询适用商城商品列表'
	}

	dataformat(json) {
		super.dataformat(json)

		const { couponTips, productList } = json.resultData || {}

		return {
			tip: (couponTips || [])[0] || '',
			pages: (productList || {}).pages || 0,
			total: (productList || {}).pageTotal || 0,
			current: (productList || {}).pageIndex || 0,
			list: ((productList || {}).list || []).map((it) => ({
				url: it.url,
				id: it.spuId,
				name: it.spuName,
				subName: it.subTitle,
				thumnail: it.faceImg,
				price: it.lowestPrice,
				tag: it.marketingFlagIcon,
				recommendAmount: it.recommendCnt || 0,
				bookingOnline: !it.offlineOnlyDisplayValue,
				labelList: (it.tagList || []).map((tag) => tag.icon),
			})),
		}
	}
}

/**
 * @brief 商城店铺
 */
export class QueryCouponShopList extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.WIRELESS
		this.url = '/coupon/queryCouponShopList'
		this.desc = '根据优惠卷id查询适用店铺列表'
	}

	dataformat(json) {
		super.dataformat(json)

		const { couponTips, storeList } = json.resultData || {}

		return {
			tip: (couponTips || [])[0] || '',
			pages: (storeList || {}).pages || 0,
			total: (storeList || {}).pageTotal || 0,
			current: (storeList || {}).pageIndex || 0,
			list: ((storeList || {}).list || []).map((it) => ({
				url: it.url,
				id: it.storeId,
				score: it.score,
				name: it.storeName,
				address: it.address,
				thumnail: it.faceImg,
				bookingFlag: !!it.bookingFlag, //是否展示评分 1是 0否
				mainCategory: it.mainCategory,
				labelList: (it.functionIconList || []).map((label) => label),
				tagList: (it.tagList || []).map((it) => ({
					id: it.tagId,
					value: it.tagContent,
				})),
				openTime: it.openTime && it.openTime.length ? (it.openTime || []).join(' ') : '--',
			})),
		}
	}
}

export class GetMemberCenterDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userMember/getMemberCenterDetail'
		this.desc = '会员中心'
	}
}

export class GetMyMember extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userMember/getMyMember'
		this.desc = '我的会员'
	}
}

export class QueryMemberOrderList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userMember/queryMemberOrderList'
		this.desc = '购买记录'
	}
}

export class QueryMemberList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userMember/queryMemberList'
		this.desc = '会员列表'
	}
}

export class QueryMemberDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userMember/queryMemberDetail'
		this.desc = '会员权益详情'
	}
}

export class GetMemberConfirmInfo extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userMember/getMemberConfirmInfo'
		this.desc = '会员开通确认'
	}
}

export class CalcDiscountAmountByCouponId extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userMember/calcDiscountAmountByCouponId'
		this.desc = '选择优惠券计算优惠金额'
	}
}

export class CreateOrderMember extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/orderMember/createOrderMember'
		this.desc = '创建会员订单'
	}

	dataformat(data) {
		// 10101002：购买会员未实名认证 88888888：只能购买一次弹框
		if (+data.resultCode === -88888888) {
			Alert('提示', data.errMsg, [
				{
					text: '知道了',
					style: {
						fontSize: '.28rem',
						color: 'rgba(255,195,0,1)',
						fontFamily: 'PingFangSC-Regular,PingFang SC',
					},
				},
			])
		} else if (+data.resultCode !== 0 && +data.resultCode !== -10101002) {
			if (UtilDevice.isApp()) {
				Bridge.appToast(data.errMsg)
			} else {
				Toast(data.errMsg)
			}
		}
		return data
	}
}

export class GetMemberCenterEquityList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userMember/getMemberCenterEquityList'
		this.desc = '会员中心权益列表'
	}
}

export class GetMemberCenterCouponList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userMember/getMemberCenterCouponList'
		this.desc = '会员中心优惠券列表'
	}
}

export class QueryMemberTicketList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userMember/queryMemberTicketList'
		this.desc = '会员权益券/优惠券'
	}
}

export class GainEquity extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userEquity/gainEquity'
		this.desc = '领取会员权益/优惠券'
	}
}

export class GetEquityDetailUrl extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userEquity/getEquityDetailUrl'
		this.desc = '获取权益明细地址，仅贵宾、安检、电瓶车'
	}
}

export class QueryUserEquityDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userEquity/queryUserEquityDetail'
		this.desc = '查询权益明细'
	}
}

export class GetOrderMemberDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/orderMember/getOrderMemberDetail'
		this.desc = '获取会员订单详情'
	}
}

export class GetEquityToUseJumpUrl extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userMember/getEquityToUseJumpUrl'
		this.desc = '权益券去使用跳转url'
	}
}

export class MemberOrderCheck extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userMember/memberOrderCheck'
		this.desc = '会员下单校验'
	}

	dataformat(data) {
		return data
	}
}

export class GetProductDetailById extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/parking/product/getProductDetailById'
		this.desc = '根据产品id获取停车产品详情'
		// test预约泊车 102
		// this.setHeader({ channelSource: '102' })
	}
}

export class GetLongParkingOrderConfirmInfo extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/longTimeParkingOrder/getOrderConfirmInfo'
		this.desc = '获取订单确认信息'
	}
}

// export class QueryUserCarList extends BaseModel {
// 	constructor(props = {}) {
// 		super(props)
// 		this.apiModule = ApiModule.WIRELESS
// 		this.url = '/userCar/queryUserCarList'
// 		this.desc = '获取用户车牌号列表'
// 	}
// }

export class QueryOrderByCarNum extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/longTimeParkingOrder/queryOrderByCarNum'
		this.desc = '根据车牌查询是否存在未完成订单'
	}
}

export class CalculateOrderAmount extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/longTimeParkingOrder/calculateOrderAmount'
		this.desc = '订单价格计算接口'
	}
}

export class LongParkingBookingAPI extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/longTimeParkingOrder/booking'
		this.desc = '预订'
	}
}

export class LongParkingPvgBookingAPI extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/longTimeParkingOrder/bookingPVGLongPark'
		this.desc = '预定浦东预约泊车'
	}

	dataformat(data) {
		// 30101001:该车辆已在场，30101002：该车辆已有订单
		if (
			+data.resultCode !== 0 &&
			+data.resultCode !== 30101001 &&
			+data.resultCode !== 30101002
		) {
			if (UtilDevice.isApp()) {
				Bridge.appToast(data.errMsg)
			} else {
				Toast(data.errMsg)
			}
		}
		return data
	}
}

export class GetOrderBookingStatus extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/longTimeParkingOrder/getOrderBookingStatus'
		this.desc = '查询预约订单状态'
	}
}

export class GetParkingOrderDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/longTimeParkingOrder/getParkingOrderDetail'
		this.desc = '获取长时停车订单详细信息'
	}
}

export class QueryUserValidEquityList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userEquity/queryUserValidEquityList'
		this.desc = '查询用户可用权益列表'
	}
}

export class QueryUserInvalidEquityList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userEquity/queryUserInvalidEquityList'
		this.desc = '查询用户失效权益列表'
	}
}

export class LongTimeParkingReschedule extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/longTimeParkingOrder/reschedule'
		this.desc = '改期'
	}
}

export class QueryOvertimeUpdateDayNum extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/longTimeParkingOrder/queryOvertimeUpdateDayNum'
		this.desc = '查询延长停车时长天数'
	}
}

export class LongTimeParkingRefundInfo extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/longTimeParkingOrder/getAvailableRefundInfo'
		this.desc = '可退信息查询'
	}
}

export class LongTimeParkingRefund extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/longTimeParkingOrder/refund'
		this.desc = '退款'
	}
}

export class QueryUserEquityTypeList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userEquity/queryUserEquityTypeList'
		this.desc = '查询用户权益分类列表'
	}
}

export class QueryUserValidEquityListPage extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userEquity/queryUserValidEquityListPage'
		this.desc = '查询用户可用权益列表分页'
	}
}

export class QueryUserInvalidEquityListPage extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userEquity/queryUserInvalidEquityListPage'
		this.desc = '查询用户失效权益列表分页'
	}
}

export class GetOrderDeliverInfos extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/orderShopping/getOrderDeliverInfos'
		this.desc = '根据订单号获取零售订单的物流配送信息'
	}

	/**
	 * @override
	 * @param json
	 * @link http://192.168.1.122:17101/swagger-ui.html#/%E9%9B%B6%E5%94%AE%E8%AE%A2%E5%8D%95%E7%9B%B8%E5%85%B3%E5%A4%84%E7%90%86%E6%8E%A5%E5%8F%A3/getOrderDeliveryInfosUsingPOST
	 * @returns {Response|*}
	 */
	dataformat(json) {
		super.dataformat(json)

		const { processNodes = [], ...rest } = json.resultData || {}

		return {
			info: UtilExt.isEmpty(rest) ? {} : rest,
			track: UtilExt.isEmpty(processNodes) ? [] : processNodes,
		}
	}
}

export class GetOrderAllDeliveryInfos extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/orderShopping/getOrderAllDeliveryInfos'
		this.desc = '根据订单号获取所有零售订单的物流配送信息'
	}

	/**
	 * @override
	 * @param json
	 * @link http://192.168.1.122:17101/swagger-ui.html#/%E9%9B%B6%E5%94%AE%E8%AE%A2%E5%8D%95%E7%9B%B8%E5%85%B3%E5%A4%84%E7%90%86%E6%8E%A5%E5%8F%A3/getOrderDeliveryInfosUsingPOST
	 * @returns {Response|*}
	 */
	dataformat(json) {
		super.dataformat(json)
		const data = json.resultData || {}
		const list = data.orderDeliverDTOList || []
		const orderDeliverDTOList = list.map((d) => {
			const { processNodes, ...rest } = d
			return {
				info: rest,
				processNodes: processNodes || {},
			}
		})
		return {
			tip: data.tip,
			orderDeliverDTOList,
		}
	}
}

export class QueryOrderDeliveryApi extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/orderDelivery/queryOrderDelivery'
		this.desc = '根据订单号获取所有商业订单的物流配送信息'
	}

	dataformat(json) {
		super.dataformat(json)
		const data = json.resultData || {}
		const list = data.orderDeliverDTOList || []
		const orderDeliverDTOList = list.map((d) => {
			const { processNodes, ...rest } = d
			return {
				info: rest,
				processNodes: processNodes || {},
			}
		})
		return {
			tip: data.tip,
			orderDeliverDTOList,
		}
	}
}

export class InitOrderConfirm extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/orderVip/initOrderConfirm'
		this.desc = '贵宾休息室-订单确认页面-产品基本信息和联系人信息'
	}
}

export class QueryDiscountByBooking extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/discount/queryDiscountByBooking'
		this.desc = '贵宾休息室-订单确认页面-查询预定场景优惠券'
	}
}

export class QueryDiscountListByType extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/discount/queryDiscountListByType'
		this.desc = '贵宾休息室-订单确认页面-根据类型查询券列表'
	}
}

export class CreateRoomOrder extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/orderVip/createRoomOrder'
		this.desc = '贵宾休息室-订单确认页面-创建贵宾休息室订单'
	}
}

export class CreateBatteryOrder extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/orderBattery/createBatteryOrder'
		this.desc = '电瓶车业务-订单确认页面-创建电瓶车订单'
	}
}

export class CreateSecurityCheckOrder extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/orderVip/createSecurityCheckOrder'
		this.desc = '贵宾休息室-订单确认页面-创建快速安检订单'
	}
}

export class GetAirportTrafficModel extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/appHome/getAirportTrafficModel'
		this.desc = '交通信息页模块'

		this.setHeader({ channelSource: '102' })
	}
}

export class QueryBannerList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/appHome/queryBannerList'
		this.desc = '获取交通信息页模块底部banner信息'
	}
}

export class GetLivePageInfos extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/appHome/getLivePage'
		this.desc = '直播落地信息页模块'
	}
}

export class QueryResourceDetailById extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/productResource/queryResourceDetailById'
		this.desc = '查询产品资源详情'
	}
}

export class GetEquityPackageProductDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/equityPackage/getEquityPackageProductDetail'
		this.desc = '获取权益卡状态/价格/库存'
	}
}

export class BookingEquityPackage extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/equityPackage/bookingEquityPackage'
		this.desc = '权益卡下单2021'
	}
}

export class GetCtripZhiXingInfo extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/ctripZhiXing/ctripChikoActivityDetail'
		this.desc = '获取智行落地页详情信息'
	}
}

export class GetVCtripZhiXingReceive extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/ctripZhiXing/ctripChikoActivityReceive'
		this.desc = '获取智行落地页领取信息'
	}
}

export class GetZhiXingIdentityDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/ctripZhiXing/getZhiXingIdentityDetail'
		this.desc = '获取个人中心智行会员详情信息'
	}
}

export class GetLSHAvailableRefundInfo extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/shaReserveParking/getAvailableRefundInfo'
		this.desc = '可退信息查询'
	}
}

export class LSHRefund extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/shaReserveParking/refund'
		this.desc = '退款'
	}
}

/** 行李管家 start */
export class GetServicePointGuide extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/luggage/booking/getServicePointGuide'
		this.desc = '机场服务点指引'
	}

	dataformat(json) {
		super.dataformat(json)
		return (json.resultData || {}).address || ''
	}
}

export class GetServiceArea extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/luggage/booking/getServiceArea'
		this.desc = '获取行李配送服务范围'
	}

	dataformat(json) {
		super.dataformat(json)
		return json.resultData || {}
	}
}

export class QueryServicePointList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/luggage/booking/queryServicePointList'
		this.desc = '查询机场服务点'
	}

	dataformat(json) {
		super.dataformat(json)
		return json.resultData || {}
	}
}

export class GetProductInfo extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/luggage/product/getProductInfo'
		this.desc = '获取行李管家产品详情'
	}

	dataformat(json) {
		super.dataformat(json)
		return json.resultData || {}
	}
}

export class GetLuggageQuestion extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/luggage/product/getProductQuestion'
		this.desc = '产品详情-常见问题'
	}

	dataformat(json) {
		super.dataformat(json)
		return json.resultData || {}
	}
}

export class QueryLuggageRule extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/luggage/booking/queryLuggageRule'
		this.desc = '查询行李规则'
	}

	dataformat(json) {
		super.dataformat(json)
		return json.resultData || {}
	}
}

export class LuggageProductList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/luggage/product/queryProductList'
		this.desc = '查询产品列表'
	}

	dataformat(json) {
		super.dataformat(json)
		return json.resultData || {}
	}
}

export class LuggageSearchCondition extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/luggage/product/getSearchCondition'
		this.desc = '查询产品列表'
	}

	dataformat(json) {
		super.dataformat(json)
		return json.resultData || {}
	}
}

export class LuggageProductInfo extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/luggage/product/getProductInfo'
		this.desc = '获取产品详情'
	}

	dataformat(json) {
		super.dataformat(json)
		return json.resultData || {}
	}
}

export class LuggageServiceArea extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/luggage/product/getProductServiceArea'
		this.desc = '服务范围'
	}

	dataformat(json) {
		super.dataformat(json)
		return json.resultData || {}
	}
}

export class LuggageCouponByProduct extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/luggage/product/getCouponByProduct'
		this.desc = '获取产品可用优惠券'
	}

	dataformat(json) {
		super.dataformat(json)
		return json.resultData || {}
	}
}

export class LuggageActivitiesByProduct extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/luggage/product/getActivitiesByProduct'
		this.desc = '获取产品可用活动'
	}

	dataformat(json) {
		super.dataformat(json)
		return json.resultData || {}
	}
}

export class InitLuggageProductInfo extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/luggage/booking/initProductInfo'
		this.desc = '行李管家下单初始化'
	}
}

export class GetLuggageSendTimeList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.noToastErr = props.noToastErr || false
		this.apiModule = ApiModule.WIRELESS
		this.url = '/luggage/booking/getSendTimeList'
		this.desc = '行李管家获取寄件时间'
	}

	dataformat(json) {
		if (this.noToastErr) {
			return json
		} else {
			super.dataformat(json)
			return json
		}
	}
}

export class GetLuggageTakeBackTimeList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.noToastErr = props.noToastErr || false
		this.apiModule = ApiModule.WIRELESS
		this.url = '/luggage/booking/getTakeBackTime'
		this.desc = '行李管家获取领回时间'
	}

	dataformat(json) {
		if (this.noToastErr) {
			return json
		} else {
			super.dataformat(json)
			return json
		}
	}
}

export class QueryDiscountByBookingLuggage extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/luggage/queryBookingDiscount'
		this.desc = '行李管家查询优惠算价'
	}
}

export class CreateLuggageOrder extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/luggage/booking/submitOrder'
		this.desc = '行李管家提交订单'
	}

	dataformat(data) {
		// 17101003:行李管家购买产品未实名，17101002：确认信息弹框
		if (
			+data.resultCode !== 0 &&
			+data.resultCode !== 17101003 &&
			+data.resultCode !== 17101002
		) {
			if (UtilDevice.isApp()) {
				Bridge.appToast(data.errMsg)
			} else {
				Toast(data.errMsg)
			}
		}
		return data
	}
}

export class QueryHotelOrHouse extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/luggage/booking/queryHotelOrHouse'
		this.desc = '查询酒店或住宅'
	}

	dataformat(json) {
		super.dataformat(json)
		return json.resultData || {}
	}
}

/** 行李管家 end */

export class GetLSHOrderConfirmInfo extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/shaReserveParking/getOrderConfirmInfo'
		this.desc = '获取订单确认信息'
	}
}

export class GetLSHOrderDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/shaReserveParking/getOrderDetail'
		this.desc = '获取订单详情'
	}
}

export class GetLSHParkInfo extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/shaReserveParking/getParkInfo'
		this.desc = '获取停车场信息'
	}
}

export class GetLSHReserveStatus extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/shaReserveParking/getReserveStatus'
		this.desc = '查询预约状态'
	}
}

export class LSHBooking extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/shaReserveParking/booking'
		this.desc = '预订'
	}
}

/** 脱敏处理 start */
export class GetUserDetail_TakeOff extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/takeOff/getUserDetail'
		this.desc = '获取用户详情'
	}
}

/** 脱敏处理 start */

export class GetAvailablePoints extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userPoints/getAvailablePoints'
		this.desc = '查询用户可用积分'
	}
}

export class QueryPointsFlow extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userPoints/queryPointsFlow'
		this.desc = '查询用户积分流水'
	}
}

export class GetPointsExplain extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ''
		this.url = `https://static.iskytrip.com/webConfig/integral/explain.json?t=${new Date().getTime()}`
		this.method = 'get'
		this.desc = '积分说明'
	}
}

export class GetShangPinPointsExplain extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ''
		this.url = `https://static.iskytrip.com/webConfig/integral/explain_shangpin.json?t=${new Date().getTime()}`
		this.method = 'get'
		this.desc = '积分说明'
	}
}

export class GetFlashSaleRule extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ''
		this.url =
			'https://publicdev.oss-cn-beijing.aliyuncs.com/webConfig/flashSale/flashSaleRule.json'
		this.method = 'GET'
		this.desc = '限时抢购规则'
	}
}

export class GetSecKillPage extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/secKill/getSecKillPage'
		this.desc = '限时抢购页面头部'
	}
}

export class GetSecKillGoods extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/secKill/getSecKillGoods'
		this.desc = '限时抢购商品查询'
	}
}

export class QueryShoppingCartCount extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/shoppingCart/queryShoppingCartCount'
		this.desc = '查询商品购物车数量'
	}
}

export class QueryRetailerInfo extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/retailer/queryRetailerInfo'
		this.desc = '查询分销员基本信息'
	}
}

export class ApplyRetailer extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/retailer/applyRetailerInfo'
		this.desc = '申请分销员'
	}
}

export class QueryRetailerCommission extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/retailOrder/queryRetailerCommission'
		this.desc = '查询分销员佣金'
	}
}

export class QueryRetailerAchievementInfo extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/retailOrder/queryRetailerAchievementInfo'
		this.desc = '查询分销员成就'
	}
}

export class QueryEmployeeStatisticsV2 extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/retailOrder/queryEmployeeStatisticsV2'
		this.desc = '查询员工分销统计信息v2'
	}
}

export class QueryRetailerEmployeeCommission extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/retailOrder/queryRetailerEmployeeCommission'
		this.desc = '查询员工佣金列表'
	}
}

export class QueryRetailerEmployeeStatistics extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/retailOrder/queryRetailerEmployeeStatistics'
		this.desc = '查询员工佣金明细'
	}
}

export class QueryRetailEquities extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/retailProduct/queryRetailEquities'
		this.desc = '查询分销权益商品列表'
	}
}

export class QueryRetailProductType extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/retailProduct/queryRetailProductType'
		this.desc = '查询分销产品类型'
	}
}

export class QueryMainRetailProducts extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/retailProduct/queryMainRetailProducts'
		this.desc = '查询分销产品列表'
	}
}

export class QueryRetailerCoupons extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/retailer/queryRetailerCoupons'
		this.desc = '查询分销员优惠券列表'
	}
}

export class BoundRetailerCoupon extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/retailer/boundRetailerCoupon'
		this.desc = '领取分销优惠券'
	}
}

export class QueryEquitiesCards extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/retailProduct/queryEquitiesCards'
		this.desc = '查询分销权益卡包列表'
	}
}

export class QueryRetailOrder extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/retailOrder/queryRetailOrder'
		this.desc = '查询分销订单'
	}
}

export class QueryRetailerInvitationRecord extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/retailOrder/queryRetailerInvitationRecord'
		this.desc = '查询近7天拉新记录'
	}
}

export class QueryWithdrawalRecords extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/retailOrder/queryWithdrawalsRecords'
		this.desc = '查询提现列表'
	}
}

export class GetWithdrawalRul extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/retailOrder/getWithdrawalsRule'
		this.desc = '获取分销提现规则'
	}
}

export class ApplyWithdrawal extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/retailOrder/applyWithdrawals'
		this.desc = '申请提现'
	}
}

export class QueryWithdrawalRecordDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/retailOrder/queryWithdrawalsRecordDetail'
		this.desc = '查询提现明细'
	}
}

export class CancelWithdrawal extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/retailOrder/cancelWithdrawals'
		this.desc = '取消提现'
	}
}

export class GenerateSunQRUrl extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/retailProduct/generateSunQRUrl'
		this.desc = '生成太阳码地址'
	}
}

export class AddProductBroseCount extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/retailProduct/addProductBroseCount'
		this.desc = '新增产品浏览记录'
	}
}

export class GetUserEquityDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userEquity/getUserEquityDetail'
		this.desc = '获取用户权益明细'
	}
}

export class QuerySignPageInfo extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/campaign/sign/querySignPageInfo'
		this.desc = '签到首页信息'
	}
}

export class QueryEvenSignNodeList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/campaign/sign/queryEvenSignNodeList'
		this.desc = '连签节点配置列表接口'
	}

	dataformat(json) {
		return json
	}
}

export class QueryEvenSignNodeDetails extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/campaign/sign/queryEvenSignNodeDetails'
		this.desc = '连签节点详情接口'
	}
}

export class SignInClick extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/campaign/sign/signIn'
		this.desc = '签到接口'
	}
}

export class QuerySignInfo extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/campaign/sign/querySign'
		this.desc = '签到查询'
	}
}

export class GetRecommendList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/appHome/getRecommendList'
		this.desc = '为你推荐'
	}
}

export class GetRecommendCategory extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/appHome/getRecommendCategory'
		this.desc = '首页推荐分类'
	}
}

export class QueryUserSignRemind extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/campaign/sign/userSignRemindSave'
		this.desc = '设置用户签到提醒'
	}
}

export class GetSpuAndStoreCouponList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/product/getSpuAndStoreCouponList'
		this.desc = '获取优惠券列表'
	}
}

export class QueryRecommendCategoryCrossFlow extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/crossFlow/queryRecommendCategory'
		this.desc = '交叉引流分类label查询'
	}

	dataformat(json) {
		super.dataformat(json)
		return json.resultData || {}
	}
}

export class QueryRecommendListCrossFlow extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/crossFlow/queryRecommendList'
		this.desc = '交叉引流推荐列表(为你推荐)'
	}

	dataformat(json) {
		super.dataformat(json)
		return json.resultData || {}
	}
}

export class LongTermParkingDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = 'https://gateway.iskytrip.com/api/wireless/parking/product/getProductDetailById'
		this.desc = '查询线上停车产品'
	}

	dataformat(json) {
		super.dataformat(json)
		return json.resultData || {}
	}
}

export class OpenMallOrderInvoice extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/orderinvoice/openOrderInvoice'
		this.desc = '商城订单开发票'
	}
}

export class GetMallOrderInvoiceDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/orderinvoice/getOrderInvoiceDetail'
		this.desc = '获取商城发票详情'
	}
}

export class SendMallOrderInvoiceToMail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/orderinvoice/sendOrderInvoiceToMail'
		this.desc = '商城发票重新发送邮件'
	}
}

export class GetMallOrderInvoicePdfUrl extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/orderinvoice/getOrderInvoicePdfUrl'
		this.desc = '根据商城订单号获取订单发票地址信息接口'
	}
}

export class ReOpenMallOrderInvoice extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.WIRELESS
		this.url = '/orderinvoice/reOpenOrderInvoice'
		this.desc = '商城订单重新开发票'
	}
}

export class User2getCoupons extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/couponCenter/user2getCoupons'
		this.desc = '免费领取优惠券'
	}
}

export class GetCouponJumpUrl extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/couponUse/getCouponJumpUrl'
		this.desc = '根据优惠卷id提供跳转URL'
	}
}

export class GetAvailableAirportGroup extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.WIRELESS
		this.url = '/coupon/getAvailableAirportGroup'
		this.desc = '优惠券去使用机场选择'
	}

	dataformat(data) {
		super.dataformat(data)
		return data.resultData || []
	}
}

export class CouponSearchAirport extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.WIRELESS
		this.url = '/coupon/searchAirport'
		this.desc = '优惠券搜索可用机场'
	}

	dataformat(data) {
		super.dataformat(data)
		return (data.resultData || []).map((it) => ({
			...it,
			airportName: it.webShortName,
		}))
	}
}

export class ModifyUserDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userCenter/modifyUserDetail'
		this.desc = '修改用户信息'
	}
}

export class GetParkingRecordDetailsApi extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/longTimeParkingOrder/getParkingRecordDetails'
		this.desc = '获取停车缴费订单详情'
	}
}

export class QueryPayPageURL extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/orderPay/queryPayPageURL'
		this.desc = '查询支付跳转页面地址'
	}
}

export class GetMallRecommendConfig extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/mall-marketing/getMallRecommendConfig'
		this.desc = '获取商城-商品落地页配置'
	}
}

export class GetMallMarketingRecommendList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/mall-marketing/getMallMarketingRecommendList'
		this.desc = '获取商城-商品列表'
	}
}

export class GetCouponDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/couponCenter/getCouponDetail'
		this.desc = '优惠券详情'
	}
}

export class GetBaseMatchProductCampaign extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/campaign/getBaseMatchProductCampaign'
		this.desc = '获取资源服务产品的最优【最新】活动'
	}
}

export class GetProductCampaignDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/campaign/getProductCampaignDetail'
		this.desc = '获取活动详情【所有营销类活动】'
	}
}

export class QueryOrderCoupons extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/campaign/crossAttract/queryOrderCoupons'
		this.desc = '查询订单活动券'
	}
}

export class ExchangeSunriseApi extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/equityPackage/exchangeSunrise'
		this.desc = '日上兑换权益'
	}
}

export class GetEquityResourceDetailsApi extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/equityPackage/getEquityResourceDetails'
		this.desc = '获取权益明细'
	}
}

export class GetGiftPackageDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/equityPackage/getGiftPackageDetail'
		this.desc = '获取权益详情'
	}
}

export class BindGiftPackage extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userPackage/bindGiftPackage'
		this.desc = '绑定转增权益卡'
	}
}

export class UnPackBlindBoxByUserPackageIdApi extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/BlindBoxCardActivity/unPackBlindBoxByUserPackageId'
		this.desc = '拆盲盒'
	}
}

export class QueryEquityList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/newComer/queryEquityList'
		this.desc = '新人权益列表'
	}
}

export class GiftGainEquity extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/newComer/gainEquity'
		this.desc = '新人礼包领取'
	}
}

export class GetSecKillHead extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/secKillProduct/getSecKillHead'
		this.desc = '抢购页面头部'
	}
}

export class QuerySecKillGoods extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/secKillProduct/querySecKillGoods'
		this.desc = '抢购商品查询'
	}
}

export class GetReserveParkingOrderDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/longTimeParkingOrder/getReserveParkingOrderDetail'
		this.desc = '获取长时停车预约订单详细信息'
	}
}

export class MakeAppointment extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/secKill/secKillAppointment'
		this.desc = '限时抢购商品预约'
	}
}

//会员二期
export class QuerySupOrder extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/orderMember/querySupOrder'
		this.desc = '查询超级会员订单'
	}
}

export class QuerySupOrderRefundInfo extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/orderMember/querySupOrderRefundInfo'
		this.desc = '查询超级会员订单退款信息'
	}
}

export class RefundSupOrder extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/orderMember/refundSupOrder'
		this.desc = '退款会员订单'
	}
}

export class QuerySupMemberResourceList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/member/querySupMemberResourceList'
		this.desc = '权益资源列表(如果有多条则进行聚合)'
	}
}

export class QuerySupMemberProductDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/member/querySupMemberProductDetail'
		this.desc = '付费会员产品详情'
	}
}

export class QuerySupMemberEquityList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/member/querySupMemberEquityList'
		this.desc = '会员中心权益列表'
	}
}

export class QuerySupMemberCouponList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/member/querySupMemberCouponList'
		this.desc = '会员中心优惠券列表'
	}
}

export class QuerySupMemberCenterCouponList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userMember/querySupMemberCenterCouponList'
		this.desc = '会员中心优惠券列表(已购买)'
	}
}

export class QuerySupMemberCenterEquityList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userMember/querySupMemberCenterEquityList'
		this.desc = '会员中心权益列表(已购买)'
	}
}

export class GetMemberPage extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userMember/getMemberPage'
		this.desc = '获取跳转会员中心页面'
	}
}

/** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ 付费会员 start */
export class QuerySupMemberProductList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/member/querySupMemberProductList'
		this.desc = '付费会员产品列表'
	}
}

export class QueryModuleListApi extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/appHome/queryModuleList'
		this.desc = '首页模块列表'
	}
}

export class CreateOrderSupMember extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/orderMember/sup/createOrderSupMember'
		this.desc = '创建会员订单'
	}
}

export class QueryWealMemberProductList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/member/queryWealMemberProductList'
		this.desc = '福利卡列表'
	}
}

/** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ 付费会员 end */

export class GetMallRecommendConfigV1 extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/namount-npiece/landing-page/config'
		this.desc = '获取商城-商品落地页配置'
	}

	dataformat(json) {
		return json
	}
}

export class GetMallMarketingRecommendListV1 extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/namount-npiece/landing-page/supList'
		this.desc = '获取商城-商品列表'
	}
}

export class IsSetUserAssetPwd extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userCenter/isSetUserAssetPwd'
		this.desc = '查询是否设置支付密码'
	}
}

export class QueryUserAllOrderList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userCenter/queryUserAllOrderList'
		this.desc = '根据订单类型返回订单列表'
	}
}

export class NfrQueryOrderDetailApi extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/nfr/queryOrderDetail'
		this.desc = 'nfr查询订单信息'
	}
}
export class OrderRefund extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/nfr/applyNfrOrderRefund'
		this.desc = 'nfr订单退款'
	}
}

export class NfrBookingResult extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/nfr/getBookingResult'
		this.desc = '查询预定结果'
	}
}

export class QueryHXHTradingRecord extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/HXHQuery/queryHXHTradingRecord'
		this.desc = '红星惠用户交易记录查询接口'
	}
}

export class QueryCampaignPointInfoList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/campaignPoint/queryCampaignPointInfoList'
		this.desc = '获取活动积分信息列表'
	}
}

export class ExchangeCampaignPoint extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/campaignPoint/exchangeCampaignPoint'
		this.desc = '兑换活动积分'
		this.toastErr = false
	}
}
/** nfr获取用户实名信息 */
export class NfrGetUserInfo extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/nfr/getUserInfo'
		this.desc = '获取用户详情'
	}
}
/** nfr实名认证 */
export class UserIdentityCertify extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/nfr/userIdentityCertify'
		this.desc = '实名认证'
	}
}

export class GetProductDetailNoticeApi extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/common/getProductDetailNotice'
		this.desc = '获取产品详情公告'
	}
}
